// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React, { useState, createRef, useEffect } from "react";
import { AVATARS } from "../../constants";

const SignIn = ({ handleSignIn }) => {
  const [username, setUsername] = useState("");
  const [loaded, setLoaded] = useState(false);
  const inputRef = createRef();

  useEffect(() => {
    setLoaded(true);
    inputRef.current.focus();
  }, [loaded]); // eslint-disable-line

  return (
    <div className="modal pos-absolute top-0 bottom-0">
      <div className="modal__el">
        <h2 className="mg-b-2">加入直播间</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <fieldset>
            <input
              name="name"
              id="name"
              ref={inputRef}
              type="text"
              className="radius"
              placeholder="输入你的昵称..."
              autoComplete="off"
              value={username}
              onChange={(e) => {
                e.preventDefault();
                setUsername(e.target.value);
              }}
            />
            <hr />

            <button
              onClick={(e) => {
                const avatar =
                  AVATARS[Math.floor(Math.random() * AVATARS.length)];
                handleSignIn(username, false, avatar);
              }}
              className="btn btn--primary rounded mg-t-1"
              disabled={!username}
            >
              进入直播间
            </button>
          </fieldset>
        </form>
      </div>
      <div className="modal__overlay"></div>
    </div>
  );
};

export default SignIn;
